import { render } from "./QuranJuzList.vue?vue&type=template&id=566866f5"
import script from "./QuranJuzList.vue?vue&type=script&lang=js"
export * from "./QuranJuzList.vue?vue&type=script&lang=js"
script.render = render

export default script